$(document).on("turbolinks:load", () => {
  if (!$("body.admin_starred_messages").length) {
    return;
  }

  $(document).on("click", ".starred-comment-icon", (event) => {
    const unstar = confirm("Are you sure that you want unstar that message?");
    if (unstar) {
      const button = $(event.target);
      const commentId = button.data().id;
      const shipmentId = button.data().shipment;
      $.ajax({
        url: `/admin/shipments/${shipmentId}/star_comment?comment_id=${commentId}`,
        processData: false,
        contentType: false,
        async: false,
        method: "PATCH",
        success: () => button.parent().remove(),
      });
    }
  });
});
